import { Link } from 'react-router-dom'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook, { filterOptions } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import FilterButtons from '../../components/FilterButtons'
import { Space } from 'antd'
export const financialDetailLinkRender = (text: any, record: any) => {
  return (
    <Link to={`/srm/financialreconciliationdetail?id=${record.id}`}>
      {text}
      {record.waitInvoice && (
        <span className={style['wait-invoice-tag']}>待开票</span>
      )}
    </Link>
  )
}

const stateRender = (text: any, record: any) => {
  return (
    <Space>
      {record.state === '驳回待修改' ? (
        <span className={style['reject-wait-amend']}>{record.state}</span>
      ) : (
        <span>{record.state}</span>
      )}
    </Space>
  )
}

export default function FinancialReconciliation() {
  const {
    dateSource,
    isTableLoading,
    pagination,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    activedFilterKey,
    onToogleFilter,
  } = useHook()
  const listColumnDict: any = {
    对账单管理: {
      listColumn: [
        {
          key: 'accountNo',
          dataIndex: 'accountNo',
          title: '对账单号',
          width: 180,
          render: financialDetailLinkRender,
        },
        {
          key: 'state',
          dataIndex: 'state',
          title: '对账单状态',
          render: stateRender,
        },
        {
          key: 'orderCount',
          dataIndex: 'orderCount',
          title: '订单数',
        },
        {
          key: 'platforms',
          dataIndex: 'platforms',
          title: '下单平台',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '对账金额',
        },
        {
          key: 'createSupplier',
          dataIndex: 'createSupplier',
          title: '提交人',
        },
        {
          key: 'createTime',
          dataIndex: 'createTime',
          title: '提交时间',
          initialValue: '提交开票后生成',
        },
        {
          key: 'assessTime',
          dataIndex: 'assessTime',
          title: '审核时间',
        },
        {
          key: 'invoiceState',
          dataIndex: 'invoiceState',
          title: '供应商开票',
        },
      ],
    },
  }
  return (
    <div>
      <Search
        fieldsData={[
          'accountNo',
          'accountState',
          'accountStartTime',
          'accountEndTime',
          'accountOpenInvoiceStatus',
        ]}
        onSearch={handleSearchClick}
        keyName="FINANCIALRECONCILIATION"
        ScreenKey="FINANCIALRECONCILIATION"
      />
      <div className={style['inner-content']}>
        <div className={style['inner-content-operate']}>
          <Buttonbar
            onRefresh={handleTableRefresh}
            headeLeftBox={
              <FilterButtons
                filterOptions={filterOptions}
                activedKey={activedFilterKey}
                onToggole={onToogleFilter}
                type="multiple"
                wrapperStyle={{ marginLeft: '16px' }}
              />
            }
          ></Buttonbar>
        </div>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict['对账单管理'].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
import { Link } from 'react-router-dom'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook, { filterOptions } from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import FilterButtons from '../../components/FilterButtons'
import { Space } from 'antd'
export const financialDetailLinkRender = (text: any, record: any) => {
  return (
    <Link to={`/srm/financialreconciliationdetail?id=${record.id}`}>
      {text}
      {record.waitInvoice && (
        <span className={style['wait-invoice-tag']}>待开票</span>
      )}
    </Link>
  )
}

const stateRender = (text: any, record: any) => {
  return (
    <Space>
      {record.state === '驳回待修改' ? (
        <span className={style['reject-wait-amend']}>{record.state}</span>
      ) : (
        <span>{record.state}</span>
      )}
    </Space>
  )
}

export default function FinancialReconciliation() {
  const {
    dateSource,
    isTableLoading,
    pagination,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    activedFilterKey,
    onToogleFilter,
  } = useHook()
  const listColumnDict: any = {
    对账单管理: {
      listColumn: [
        {
          key: 'accountNo',
          dataIndex: 'accountNo',
          title: '对账单号',
          width: 180,
          render: financialDetailLinkRender,
        },
        {
          key: 'state',
          dataIndex: 'state',
          title: '对账单状态',
          render: stateRender,
        },
        {
          key: 'orderCount',
          dataIndex: 'orderCount',
          title: '订单数',
        },
        {
          key: 'platforms',
          dataIndex: 'platforms',
          title: '下单平台',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '对账金额',
        },
        {
          key: 'createSupplier',
          dataIndex: 'createSupplier',
          title: '提交人',
        },
        {
          key: 'createTime',
          dataIndex: 'createTime',
          title: '提交时间',
          initialValue: '提交开票后生成',
        },
        {
          key: 'assessTime',
          dataIndex: 'assessTime',
          title: '审核时间',
        },
        {
          key: 'invoiceState',
          dataIndex: 'invoiceState',
          title: '供应商开票',
        },
      ],
    },
  }
  return (
    <div>
      <Search
        fieldsData={[
          'accountNo',
          'accountState',
          'accountStartTime',
          'accountEndTime',
          'accountOpenInvoiceStatus',
        ]}
        onSearch={handleSearchClick}
        keyName="FINANCIALRECONCILIATION"
        ScreenKey="FINANCIALRECONCILIATION"
      />
      <div className={style['inner-content']}>
        <div className={style['inner-content-operate']}>
          <Buttonbar
            onRefresh={handleTableRefresh}
            headeLeftBox={
              <FilterButtons
                filterOptions={filterOptions}
                activedKey={activedFilterKey}
                onToggole={onToogleFilter}
                type="multiple"
                wrapperStyle={{ marginLeft: '16px' }}
              />
            }
          ></Buttonbar>
        </div>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict['对账单管理'].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}
